import { FC, memo, useRef } from 'react'

import VideoFrame from 'components/webinar/video-block/video-frame'
import VideoBlockInfoProject from 'components/webinar/video-block-project/video-block-info-project'
import useLectorsSubscription from 'hooks/useLectorsSubscription'

import { IMaterial } from 'constants/types/webinar.types'
import { PLACEFLAG_PAST, PLACEFLAG_VIDEO } from 'constants/analytic-data'
import { getPlayerMethods } from 'components/webinar/video-block/utils'

import styles from './video-block-project.module.scss'

interface IVideoBlockProject {
  dataset: IMaterial
  isFullInShow?: boolean
  isWebinar?: boolean
}

const VideoBlockProject: FC<IVideoBlockProject> = ({ dataset, isFullInShow, isWebinar }) => {
  const isMustBePaid = dataset?.isAcceptAllow === false //Именно false, а не undefined, например
  const place = isWebinar ? PLACEFLAG_PAST : PLACEFLAG_VIDEO

  const refPlayer = useRef<any>(null)

  const handleTimeCode = (time: number) => getPlayerMethods(time, dataset.videoLink, refPlayer)
  const lectorsData = useLectorsSubscription(dataset.Lecturs, place)

  return (
    <div className={styles.translationBlock}>
      <div className={styles.videoWrapper}>
        <VideoFrame dataset={dataset} isMustBePaid={isMustBePaid} refPlayer={refPlayer} />
      </div>

      {isFullInShow && (
        <div>
          <VideoBlockInfoProject
            dataset={dataset}
            lectorsData={lectorsData}
            isMustBePaid={isMustBePaid}
            handleTimeCode={handleTimeCode}
            isEnded
          />
        </div>
      )}
    </div>
  )
}

export default memo(VideoBlockProject)
